import { useRecoilValue } from 'recoil';

import { FullScreen } from '../../components/FullScreen';
import { ControlPanel } from '../../entities/projectPlan/grid';
import { FontSizeControl, useGridScale } from '../../features/grid-settings';
import useExportToExcelRowsFromGrid from '../../hooks/useExportToExcelRowsFromGrid';
import { EntitiesPageWrapper } from '../../modules/EntitiesGrid';
import { ProjectTasksGrid } from '../../modules/Tasks';
import { useImportProjectTasksFromExcel } from '../../modules/Tasks/state/projectTasks';
import { useDefaultTasksGridSettings } from '../../modules/Tasks/state/tasks';
import { useExportToExcelProjects } from '../../state/export';
import { userEventSettings } from '../../state/user';

const ProjectPlan = () => {
  const userEventSetting = useRecoilValue(userEventSettings);
  const scale = useGridScale('pmp');
  const { ref: gridRef, ...gridDefaultSettings } = useDefaultTasksGridSettings({
    compact: userEventSetting.pmpGridSettings.viewMode === 'compact',
    scale,
  });
  const { execute: exportToExcel } = useExportToExcelProjects();
  const exportToExcelCallback = useExportToExcelRowsFromGrid(gridRef, exportToExcel);
  const { execute: importFromExcelCallback, loading: loadingImportFromExcel } = useImportProjectTasksFromExcel();

  const onImportFromExcel = (file: File) => {
    importFromExcelCallback(file);
  };

  return (
    <FullScreen>
      <EntitiesPageWrapper>
        <ControlPanel
          onExportToExcel={exportToExcelCallback}
          onImportFromExcel={onImportFromExcel}
          loadingImportFromExcel={loadingImportFromExcel}
          fontSizeControl={<FontSizeControl gridType='pmp' />}
        />
        <ProjectTasksGrid gridRef={gridRef} scale={scale} {...gridDefaultSettings} />
      </EntitiesPageWrapper>
    </FullScreen>
  );
};

export default ProjectPlan;
